<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <!--
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">Seja nosso Patrocinador</v-btn>
      </template>
      -->
    <v-card>
      <v-toolbar dark color="secundary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Seja nosso Patrocinador</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Fechar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>

        <Patrocinador />

<!--
        <v-card :loading="loading" class="mx-auto my-12" max-width="474">
          <v-img height="250" :src="image04"></v-img>

          <v-card-title>Seja nosso patrocinador</v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <v-rating
                :value="4.5"
                color="amber"
                dense
                half-increments
                readonly
                size="14"
              ></v-rating>

              <div class="grey--text ml-4">4.5 (413)</div>
            </v-row>

            <div class="my-4 subtitle-1 black--text">
              $ • Patrocinio, Apoio, Suporte
            </div>

            <div>
              O VIOLENT NOISE é um espaço independente e feito para os fãs e
              músicos das bandas. Sua ajuda será muito bem-vinda, pois isso irá
              auxiliar nos custos de manutenção do site. Quer e pode contribuir?
            </div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-title>Formas de Apoio</v-card-title>

          <v-card-text>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="basil"
              grow
            >
              <v-tab>
                <v-img max-width="150" :src="imagemp"></v-img>
              </v-tab>
              <v-tab>
                <v-img max-width="150" :src="imagepp"></v-img>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-img :src="imageqrmp"></v-img>
              </v-tab-item>
              <v-tab-item>
                <v-img :src="imageqrpp"></v-img>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions>
            <v-btn color="deep-purple accent-4" text @click="dialog = false">
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
-->        
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import Patrocinador from '@/components/Cards/Patrocinador.vue'

export default {
  components: { Patrocinador },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  watch: {
    IsPatrocinador(val) {
      if (!val) return;

      if (val == true) {
        this.dialog = true;

        this.$store.commit("setIsPatrocinador", false);
      }
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "IsPatrocinador",
    "IsMobile"
  ])
};
</script>

<style></style>
